<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject == 0" v-model='theProjectId' @change="theProjectAllChange" size="small"
          clearable placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>

        <el-input v-model="getCustomList_data.customName" placeholder="请输入客户名" clearable size='small'
          style="max-width:200px;" />
        <el-button v-click.getCustomList type="primary" icon='el-icon-search' size='small' style='margin-left:10px;'>搜索
        </el-button>
        <el-button type="primary" size='small' style='margin-left:10px;' @click="Out">导出
        </el-button>

      </el-col>
      <el-col :span="6">
        <el-button v-if='addCustom' @click=" $form('addCustom')" size='small' type="primary" style="float:right"
          icon='el-icon-circle-plus'>添加客户属性
        </el-button>
      </el-col>
    </el-row>

    <mytable :tableColums='tableColums_getCustomList' api='getCustomList ::customId' updateapi='updateCustom'
      :height="H - 165" ref="getCustomListTable">
    </mytable>

    <myform :viewobj='{
        addCustom: ["新增客户属性信息", "el-icon-circle-plus"],
        updateCustom: ["修改客户属性信息", "el-icon-edit-outline"],
        $succeed$: getCustomList
      }' @close='$form("addCustom", "reset")'>
      <!-- <hide slot='customId' /> -->
    </myform>

    <myform view.getCustomDetails='查看详情' @opened="form => form.title += ' | @' + Myformdata.customName">
      <div v-if='Myformdata'>
        <el-descriptions :column="1" border :labelStyle="{
        color: '#409EFF',
        textAlign: 'center',
        width: '20%',
        fontSize: '12px'
      }" :contentStyle="{ textAlign: 'left', width: '80%', fontSize: '12px' }">

          <el-descriptions-item
            :contentStyle="{ textAlign: 'center', fontSize: '12px', display: 'flex', justifyContent: 'space-around' }"
            label="客户名称">
            {{ getCustomDetails_data.data.customName }}

          </el-descriptions-item>

        </el-descriptions>
        <el-table v-if="getCustomDetails_data.data.customAttrList" ref="kehuTable"
          :data="getCustomDetails_data.data.customAttrList" stripe border style="width: 100%" max-height="500px"
          :cell-style="{ textAlign: 'center' }" :header-cell-style="{
        textAlign: 'center',
        background: 'rgba(0,170,255,0.5)',
        color: 'black',
        border: 'none'
      }">
          <el-table-column prop="qtName" label="题目名称" fixed="left">
          </el-table-column>
          <el-table-column prop="qttName" label="题目类型">
          </el-table-column>
          <el-table-column prop="qtOrder" label="排序" fixed="left">
          </el-table-column>
          <el-table-column prop="qtiValue" label="所选答案">
            <template slot-scope="scope">
              <img class="el-upload-list__item-thumbnail" :src="scope.row.qtiValue" alt=""
                style="width: 50px;height: 50px;" @click="PreviewVideo(scope.row.qtiValue)"
                v-if="scope.row.qttId == 3 && scope.row.qtiValue != '跳过'">
              <span v-if="scope.row.qttId == 3 && scope.row.qtiValue == '跳过'">{{ scope.row.qtiValue }}</span>
              <span v-if="scope.row.qttId != 3">{{ scope.row.qtiValue }}</span>
            </template>
          </el-table-column>

        </el-table>
        <!-- <div>创建人 :  {{Myformdata.userName}}</div>
        <div>客户名称 :  {{Myformdata.customName}}</div>
        <div>客户行业 :  {{Myformdata.btName}}</div> -->
        <div>创建时间 : {{ Myformdata.createtime }}</div>
      </div>
      <hide slot='customId' />
    </myform>

  </div>
</template>

<script>
import myhttp from '../../utils/myhttp';
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      baseUrl: $Api.baseUrl_online,
      formDetail: {},
      formBuilding: {},
      DiyList: [],
      companyFold: false,
      customId: null,
      theBusinessType: "",
      theProjectId: "",
      theUserProject: "",
      tableColums_getCustomList: {
        $selection: true,

        customName: '客户名称',

        // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],

        $operation: [
          '操作', 200,
          // this.updateCustom && `@text: 编辑#success
          //  @click: $form("updateCustom",$row)
          // `,
          this.deleteCustom && `@text: 删除#danger
           @click: _confirm('确定要删除该客户属性吗?')
                   .trigger('deleteCustom',{customId:$row.customId})
                   .trigger('getCustomList')
          `,
          this.getCustomDetails && `@text: 查看详情#success
           @click: $form("getCustomDetails",$row), getCustomDetails({customId:$row.customId})
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    PreviewVideo(url) {
      document.PreviewVideo(url)
    },
    openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    Out(e) {
      const selection = Object.keys(this.$refs.getCustomListTable.$MyTableCache);
      console.log(selection.join());
      const bulkdata = {
        projectId: this.theProjectId,
        customName: this.getCustomList_data.customName,
        customIds: selection.join() || ''
      }
      this.openLoading();
      var s = qs.stringify(bulkdata);
      var that = this
      axios({
        method: 'post',
        url: that.baseUrl + '/opportunity/custom/exportCustom',
        data: s,
        withCredentials: true,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'token': A.local('$Usertoken'),
          'projectId': +A.local('$projectId'),
        }
      }).then(function (res) {
        if (res.data) {
          that.loading.close();
          let a = document.createElement('a');
          //ArrayBuffer 转为 Blob
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel"
          });
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", '客户.xlsx');
          a.click();
          that.$message({
            message: "成功",
            type: "success"
          });
          that.BulkClose()
        }
      })
    },
    theBusinessTypeChange(e) {
      this.theBusinessType = e;
      this.getCustomList({ currentPage: 1, btId: this.theBusinessType });
    },
    theProjectAllChange(e) {
      this.theProjectId = e;
      this.getCustomList({ projectId: this.theProjectId, btId: this.theBusinessType });
    },
  },

  created() {
    this.theUserProject = A.local('$projectId');
    if (this.theUserProject == 0) {
      this.getProjectList({ pageSize: 0 });
    } else {
      this.theProjectId = this.theUserProject;
    }
    this.getCustomList({ projectId: this.theProjectId, btId: this.theBusinessType });
  },
  mounted() {

  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/help/CustomManage.vue